/* eslint-disable no-control-regex */
export const URL_REGEX =
  /(?:^|\s)((https?:\/\/)?(?:localhost|[\w-]+(?:\.[\w-]+)+)(:\d+)?(\/\S*)?)/;
